/**
 * The context read for every workspace component (spec #44 §3).
 *
 * Fan-out, not fetch: a component that needs presence, unread, the head or
 * a lane reads it from here. That is what keeps the head poller singular —
 * there is no path by which a component can start its own.
 */

import { useContext } from 'react';

import { WorkspaceContext } from '../contexts/WorkspaceContext';
import type { WorkspaceContextValue } from '../contexts/WorkspaceContext';

export function useWorkspace(): WorkspaceContextValue {
  const value = useContext(WorkspaceContext);
  if (!value) {
    throw new Error('useWorkspace must be used inside a WorkspaceProvider');
  }
  return value;
}
